import React from 'react';
import { 
  Box, 
  Container, 
  Grid, 
  Typography, 
  Link as MuiLink, 
  Divider,
  Stack
} from '@mui/material';
import { Link } from 'react-router-dom';

import AppointmentButton from './AppointmentButton';
import { openCookieSettings } from '../config/analytics';
import { cabinet } from '../config/cabinet';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    navigation: [
      { name: 'Accueil', path: '/' },
      { name: 'Le cabinet', path: '/about' },
      { name: 'Soins proposés', path: '/services' },
      { name: 'Tarifs', path: '/pricing' },
      { name: 'Contact', path: '/contact' }
    ],
    services: [
      { name: 'Chiropraxie Générale', path: '/services#chiropraxie-generale' },
      { name: 'Thérapie des Tissus Mous', path: '/services#therapie-tissus-mous' },
      { name: 'Dry Needling', path: '/services#dry-needling' },
      { name: 'Ventouses', path: '/services#ventouses' },
      { name: 'Ondes de Choc', path: '/services#ondes-de-choc' },
      { name: 'Réhabilitation', path: '/services#rehabilitation' }
    ]
  };

  return (
    <Box component="footer" sx={{ bgcolor: 'primary.dark', color: 'white', py: 6, mt: 'auto' }}>
      <Container maxWidth="lg">
        <Grid container spacing={4} justifyContent="center">
          {/* About */}
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              {cabinet.name}
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.8 }}>
              Jade Philippe, chiropracteur à Creully-sur-Seulles. Une prise en charge personnalisée des douleurs musculaires et articulaires.
            </Typography>
            <Typography variant="body2" gutterBottom>
              <strong>Email :</strong> {cabinet.email}
            </Typography>
            <AppointmentButton color="secondary" sx={{ mt: 2 }} />
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="subtitle1" component="div" gutterBottom fontWeight={600}>
              Navigation
            </Typography>
            <Stack spacing={1}>
              {footerLinks.navigation.map((link) => (
                <MuiLink 
                  key={link.name}
                  component={Link}
                  to={link.path}
                  color="inherit"
                  underline="hover"
                  sx={{ opacity: 0.8, '&:hover': { opacity: 1 } }}
                >
                  {link.name}
                </MuiLink>
              ))}
            </Stack>
          </Grid>

          {/* Services */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="subtitle1" component="div" gutterBottom fontWeight={600}>
              Les soins
            </Typography>
            <Stack spacing={1}>
              {footerLinks.services.map((link) => (
                <MuiLink 
                  key={link.name}
                  component={Link}
                  to={link.path}
                  color="inherit"
                  underline="hover"
                  sx={{ opacity: 0.8, '&:hover': { opacity: 1 } }}
                >
                  {link.name}
                </MuiLink>
              ))}
            </Stack>
          </Grid>
        </Grid>

        <Divider sx={{ borderColor: 'rgba(255,255,255,0.1)', my: 4 }} />
        
        <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'space-between' }, flexDirection: { xs: 'column', md: 'row' }, alignItems: 'center', textAlign: { xs: 'center', md: 'left' }, gap: 1 }}>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            © {currentYear} {cabinet.name}. Tous droits réservés.
          </Typography>
          <Stack direction="row" spacing={2} sx={{ mt: { xs: 1, md: 0 } }}>
            <MuiLink
              component={Link}
              to="/confidentialite"
              color="inherit"
              underline="hover"
              sx={{ opacity: 0.8, '&:hover': { opacity: 1 } }}
            >
              Confidentialité
            </MuiLink>
            <MuiLink
              component="button"
              type="button"
              onClick={openCookieSettings}
              color="inherit"
              underline="hover"
              sx={{
                opacity: 0.8,
                '&:hover': { opacity: 1 },
                background: 'none',
                border: 0,
                padding: 0,
                font: 'inherit',
                cursor: 'pointer',
              }}
            >
              Cookies
            </MuiLink>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 